/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

:host(:focus-visible) {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
  border-radius: var(--qds-focus-border-radius);
  outline-offset: -2px;
}

button {
  background-color: var(--qds-theme-panel-subsection-standard-background);
  width: 100%;
  display: flex;
  align-items: center;
  border: none;
  color: var(--qds-theme-text-standard);
  padding: var(--qds-list-item-large-padding-vertical)
    var(--qds-list-item-large-padding-horizontal);
  gap: var(--qds-list-item-standard-gap-internal);
  justify-content: space-between;
  cursor: default;
  min-height: var(--qds-list-item-large-height);
  border-block-end: var(--qds-list-border-width) solid
    var(--qds-theme-divider-standard);

  qds-icon {
    color: var(--qds-theme-text-standard);
    font-size: var(--qds-control-large-icon-size);
    transform: scaleX(var(--qds-direction-factor, 1));
    flex-shrink: 0;
  }

  .qds-mobile-title {
    text-align: start;
    font: var(--qds-list-item-large-title);
  }
}

button:hover {
  background-color: var(--qds-theme-interactive-background-hover);
}

button:active {
  background-color: var(--qds-theme-interactive-background-pressed);
}

:host(:last-of-type) {
  .mobile-item {
    border-block-end: none;
  }
}

.qds-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-inline: var(--qds-control-tab-standard-padding-horizontal);
  height: var(--qds-control-tab-standard-height);
  gap: var(--qds-control-tab-standard-padding-horizontal);
  border-radius: 0 var(--qds-signature-line-connection-cap-radius)
    var(--qds-signature-line-connection-cap-radius) 0;

  &.qds-selected {
    background-color: var(--qds-control-tab-emphasized-selected);
  }

  &:hover {
    background-color: var(--qds-theme-interactive-background-hover);
  }

  &:active {
    background-color: var(--qds-theme-interactive-background-pressed);
  }

  &.qds-selected::after {
    background-color: var(--qds-theme-signature-color-default);
    border-radius: var(--qds-signature-line-connection-cap-radius);
    content: "";
    cursor: pointer;
    width: var(--qds-signature-line-connection-width);
    position: absolute;
    inset-inline-end: 0;
    inset-block: 0;
  }

  qds-icon {
    color: var(--qds-theme-title);
    width: var(--qds-control-tab-small-icon-size);
    height: var(--qds-control-tab-small-icon-size);
  }

  .qds-label {
    font: var(--qds-list-item-standard-title);
  }

  &.qds-selected .qds-label {
    font: var(--qds-list-item-standard-title-emphasized);
  }
}

img {
  max-width: var(--qds-control-tab-small-icon-size);
  max-height: var(--qds-control-tab-small-icon-size);
}
